import API from 'API';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { Button, Divider, Input, Skeleton } from 'antd';
import { FilePdfOutlined, PlusCircleOutlined, RobotOutlined } from '@ant-design/icons';
import StudentExercises from 'components/general/StudentExercises';
import ChatBot from '../../EmbedPage/ChatBot';
import { correct_media } from 'general_function';
import { NotFound } from 'AppRoute';
import ScormPlayer from 'components/general/ScormPlayer';
// import ChatBot from './ChatBot';

function correct_time_format(time) {
    var min = Math.floor(time / 60)
    var sec = Math.floor(time % 60)
    if (min < 10) min = "0" + min
    if (sec < 10) sec = "0" + sec
    return `${min}:${sec}`
}

function TimeLine({ timeLine, setTimeLine }) {
    return <>
        {timeLine.map(item => <div style={{ textAlign: "center" }}>
            <Input style={{ width: 50 }}
                value={Math.floor(item.start_time / 60)} onChange={(e) => {
                    item.start_time = +e.target.value * 60 + item.start_time % 60
                    item.duration = item.end_time - item.start_time
                    setTimeLine(JSON.parse(JSON.stringify(timeLine)))
                }}
            />
            :<Input style={{ width: 50 }}
                value={item.start_time % 60} onChange={(e) => {
                    if (+e.target.value > 59) e.target.value = 59;
                    item.start_time = Math.floor(item.start_time / 60) * 60 + +e.target.value % 60
                    item.duration = item.end_time - item.start_time
                    setTimeLine(JSON.parse(JSON.stringify(timeLine)))
                }}
            /> - <Input style={{ width: 50 }}
                value={Math.floor(item.end_time / 60)} onChange={(e) => {
                    item.end_time = +e.target.value * 60 + item.end_time % 60
                    item.duration = item.end_time - item.start_time
                    setTimeLine(JSON.parse(JSON.stringify(timeLine)))
                }}
            />
            :<Input style={{ width: 50 }}
                value={item.end_time % 60} onChange={(e) => {
                    if (+e.target.value > 59) e.target.value = 59;
                    item.end_time = Math.floor(item.end_time / 60) * 60 + +e.target.value % 60
                    item.duration = item.end_time - item.start_time
                    setTimeLine(JSON.parse(JSON.stringify(timeLine)))
                }}
            /> - <Input style={{ width: 70 }}
                value={item.duration} onChange={(e) => {
                    item.duration = +e.target.value
                    setTimeLine(JSON.parse(JSON.stringify(timeLine)))
                }}
            />s
        </div>)}
        <div style={{ textAlign: "center" }}>
            <Button type='primary' onClick={() => {
                setTimeLine([...timeLine, {
                    start_time: 0,
                    end_time: 0,
                    duration: 0,
                }])
            }}>
                <PlusCircleOutlined />
            </Button>
        </div>
    </>
}

export default function StudentLesson({ id }) {
    // const { id } = useParams();
    const [lesson, setLesson] = useState(null);
    const [loading, setLoading] = useState(true);
    const [timeLine, setTimeLine] = useState([]);
    const [feedback, setFeedback] = useState(null);
    const [quizzes, setQuizzes] = useState([]);
    const [essays, setEssays] = useState([]);
    const [studentQuizzes, setStudentQuizzes] = useState([]);
    const [studentEssays, setStudentEssays] = useState([]);
    const [gettingFeedback, setGettingFeedback] = useState(false);
    const [openChatBot, setOpenChatBot] = useState(false);
    useEffect(() => {
        API.get(`student/lessons/${id}/`)
            .then(res => {
                setLesson(res.data);
                setQuizzes(res.data.quizzes);
                setEssays(res.data.essays);
                setStudentQuizzes(res.data.student_quizzes);
                setStudentEssays(res.data.student_essays);
            })
            .catch(error => {
                console.log(error)
            })
            .finally(() => {
                setLoading(false);
            })
    }, [id])

    useEffect(() => {
        if (!lesson) return;
        document.title = lesson.name;
    },[lesson])

    return loading ? <Skeleton active /> : !lesson ? <NotFound />
    : <>
        <Divider style={{ fontSize: 20 }}>{lesson.name}</Divider>
        <p>{lesson.description}</p>
        {lesson.scorms.length > 0 && <div>
            <ScormPlayer scorm={lesson.scorms[0]}/>
        </div>}
        <div style={{ textAlign: "center" }}>{lesson.video ? <>
            <video width="640" controls style={{ maxWidth: "100%" }}>
                <source src={correct_media(lesson.video.file)} type="video/mp4" />
            </video>
        </> : "Chưa có video"}</div>
        <ul>
            {lesson.pdf_files.length === 0 ? <>Bài học này chưa có tài liệu nào</> : lesson.pdf_files.map(item =>
                <li key={item.id}>
                    <a href={correct_media(item.file)} target='_blank' rel="noreferrer">
                        <FilePdfOutlined /> {item.file.split('/').pop()}
                    </a>
                </li>)
            }
        </ul>
        <div style={{ textAlign: "center " }}>
            <Button type='primary' loading={gettingFeedback} onClick={() => {
                setGettingFeedback(true)
                API.post("generate-feedback/", { lesson_id: id })
                    .then(res => {
                        setFeedback(res.data)
                    })
                    .catch(error => {
                        console.log(error)
                    })
                    .finally(() => {
                        setGettingFeedback(false)
                    })
            }}>
                Đánh giá kết quả
            </Button>
        </div>
        {feedback && <div>
            <b>Đánh giá chung:</b><br />
            <div>{feedback.feedback}</div>
            <b>Khả năng hiểu bài:</b><br />
            <div>{feedback.understand}</div>
            <b>Phần trắc nghiệm:</b><br />
            <div>{feedback.quiz}</div>
            <b>Phần tự luận:</b><br />
            <div>{feedback.essay}</div>
            <b>Cần cải thiện:</b><br />
            <div>
                {feedback.improve}<br />
                {feedback.rewatch?.length > 0 && <>
                    <b>Bạn nên xem lại video ở những phân đoạn sau:</b>
                    <ul>
                        {feedback.rewatch.map(item => <li>
                            <b>{correct_time_format(item.start_time)} - {correct_time_format(item.end_time)}:</b> {item.content}
                        </li>)}
                    </ul>
                </>}
            </div>
        </div>}
        <StudentExercises
            quizzes={quizzes} setQuizzes={setQuizzes}
            essays={essays} setEssays={setEssays}
            studentQuizzes={studentQuizzes} setStudentQuizzes={setStudentQuizzes}
            studentEssays={studentEssays} setStudentEssays={setStudentEssays}
            lesson_id={lesson.id} />
        <Button type="primary" onClick={() => setOpenChatBot(!openChatBot)} style={{
            position: "fixed", bottom: 15, right: 15,
            transition: "opacity 0.3s ease, transform 0.3s ease",
            opacity: !openChatBot ? 1 : 0,
            transform: !openChatBot ? "translateY(0)" : "translateY(20px)",
        }}>
            <RobotOutlined />
        </Button>
        <div style={{
            height: 570, maxHeight: "calc(100vh - 30px)",
            width: 500, maxWidth: "calc(100vw - 15px)",
            position: "fixed", bottom: 15, right: 10,
            transition: "opacity 0.3s ease, transform 0.3s ease",
            opacity: openChatBot ? 1 : 0,
            transform: openChatBot ? "translateY(0)" : "translateY(20px)",
            pointerEvents: openChatBot ? "auto" : "none",
            zIndex: 10000,
        }}>
            <ChatBot lesson_id={lesson.id} setClose={() => setOpenChatBot(false)} />
        </div>
    </>
}
